import { createComponent } from "@helpers/admin";
import component from "@template/blocks/domain/DomainNameSearchBackorder";

export const DomainNameSearchBackorder = createComponent({
  label: "Search (Backorder)",
  component,
  fields: {
    input: {
      label: "Input",
      type: "input",
    },
    submit: {
      label: "Submit",
      type: "button",
    },
    href: {
      label: "HREF",
      type: "text",
    },
  },
});
